module.exports = __webpack_public_path__ + "static/media/C_F01.363cefac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/C_F01.png
// module id = 72
// module chunks = 0